import axios from "axios";
import api from "../utils/axiosInterceptor";
const API_URL = process.env.REACT_APP_API_URL;
export const Register = async (data) => {
	try {
		const config = {
			headers: {
				"Content-Type": data instanceof FormData ? "multipart/form-data" : "application/json",
			},
		};
		const response = await axios.post(`${API_URL}/api/register`, data, config);
		return response.data;
	} catch (error) {
		console.error("Register error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const SignupService = async (data) => {
	try {
		const config = {
			headers: {
				"Content-Type": data instanceof FormData ? "multipart/form-data" : "application/json",
			},
		};
		const response = await axios.post(`${API_URL}/api/signup`, data, config);
		return response.data;
	} catch (error) {
		console.error("Register error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const Login = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/login`, data);
		return response.data;
	} catch (error) {
		console.error("Login error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const ForgotPassword = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/forgot-password`, data);
		return response.data;
	} catch (error) {
		console.error("Forgot password error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyOTP = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Code verification error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyLoginOtp = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/login/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Login Code verification error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const ResendLoginOtp = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/login/resend-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Resend login Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const ResetPassword = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/reset-password`, data);
		return response.data;
	} catch (error) {
		console.error("Password reset error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const GetProfileDetails = async () => {
	try {
		const response = await api.get(`${API_URL}/api/get-profile-details`);
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const UpdateProfile = async (data) => {
	try {
		const config = {
			headers: {
				"Content-Type": data instanceof FormData ? "multipart/form-data" : "application/json",
			},
		};
		const response = await api.post(`${API_URL}/api/update-profile`, data, config);
		return response.data;
	} catch (error) {
		console.error("Update profile error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const ChangePassword = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/change-password`, data);
		return response.data;
	} catch (error) {
		console.error("Change password error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyMailService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/verify-email`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in  function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const SendEmailChangeOtp = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/profile/email/send-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Send email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyEmailChangeOtp = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/profile/email/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const SendPhoneChangeOtp = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/profile/phone/send-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Send phone change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyPhoneChangeOtp = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/profile/phone/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify phone change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const UnsubscribeNotifications = async (data) => {
	try {
		const response = await axios.get(`${API_URL}/api/unsubscribe`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Unsubscribe notifications error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyMailAndBusinessVerifyService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/verify-mail/business-verify`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};
export const BusinessVerifyService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/business-verify`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const BusinessVerifyWithPhoneService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/phone-number-check`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const VerifyEmailAndBusinessChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/verify-email-otp/business`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};
